import React, {useEffect, useState} from "react";
import Dropdown from "../../dropdown/dropdown";
import {instanceMob} from "../../../utils/utils";
import useLocationStore from "../config/use-location-store";

const SalesCategoryPanel = () => {
    const years = [
        {id: 1, name: "2023"},
        {id: 2, name: "2024"},
        {id: 3, name: "2025"},
        {id: 4, name: "2026"},
        {id: 5, name: "2027"},
        {id: 6, name: "2028"},
    ];

    const months = [
        {id: 1, name: "Enero"},
        {id: 2, name: "Febrero"},
        {id: 3, name: "Marzo"},
        {id: 4, name: "Abril"},
        {id: 5, name: "Mayo"},
        {id: 6, name: "Junio"},
        {id: 7, name: "Julio"},
        {id: 8, name: "Agosto"},
        {id: 9, name: "Septiembre"},
        {id: 10, name: "Octubre"},
        {id: 11, name: "Noviembre"},
        {id: 12, name: "Diciembre"},
    ];

    const [salesCategories, setSalesCategories] = useState([]);
    const [selectedYear, setSelectedYear] = useState("2025");
    const [selectedMonth, setSelectedMonth] = useState("Octubre");
    const [selectedType, setSelectedType] = useState("product");
    const [selectedTypeLabel, setSelectedTypeLabel] = useState("Ventas de productos tienda");

    const {selectedLocation} = useLocationStore();

    const fetchSalesData = (year: string, month: string, saleType: string) => {
        const monthId = months.find((m) => m.name === month)?.id || 10;
        const locationId = selectedLocation?.id || 73;

        instanceMob
            .get(
                `admin/accounting/sale-summary?year=${year}&month=${monthId}&sale_type=${saleType}&location_id=${locationId}`
            )
            .then((response) => {
                let data = [];

                if (response.data?.products?.length > 0) {
                    data = response.data.products;
                } else if (response.data?.plan?.length > 0) {
                    data = response.data.plan;
                }
                setSalesCategories(data);
            })
            .catch((error) => {
                console.error("Error fetching sales summary:", error);
                setSalesCategories([]);
            });
    };

    useEffect(() => {
        if (selectedYear && selectedMonth && selectedType) {
            fetchSalesData(selectedYear, selectedMonth, selectedType);
        }
    }, [selectedYear, selectedMonth, selectedType, selectedLocation]);

    return (
        <div className="accounting-dashboard-sales-category-panel d-flex flex-column p-4 gap-3">
            <div className="d-flex flex-row justify-content-between align-items-center">
                <div className="accounting-dashboard-sales-category-panel-title">
                    Resumen de Ventas por Línea
                </div>
                <div className="d-flex flex-row gap-1">
                    <Dropdown
                        placeholder="Selecciona un tipo"
                        width={185}
                        items={[
                            {id: "plan", name: "Ventas de planes gimnasio"},
                            {id: "product", name: "Ventas de productos tienda"},
                        ]}
                        onSelect={(item) => {
                            setSelectedType(item.id);
                            setSelectedTypeLabel(item.name);
                        }}
                        initialValue={selectedTypeLabel}
                    />
                    <Dropdown
                        placeholder="Año"
                        width={89}
                        items={years}
                        onSelect={(item) => setSelectedYear(item.name)}
                        initialValue={selectedYear}
                    />
                    <Dropdown
                        placeholder="Mes"
                        width={89}
                        items={months}
                        onSelect={(item) => setSelectedMonth(item.name)}
                        initialValue={selectedMonth}
                    />
                </div>
            </div>

            <div className="accounting-dashboard-sales-category-panel-subtitle">
                Analiza qué línea de productos genera más ingresos.
            </div>

            <div className="accounting-dashboard-sales-category-table-container pe-2">
                <div className="accounting-dashboard-sales-category-table-header px-2 py-2">
                    <span>Categoría del producto</span>
                    <span className="text-center">Ventas Totales</span>
                </div>

                <div className="accounting-dashboard-sales-category-table-body">
                    {salesCategories.length > 0 ? (
                        salesCategories.map((item: any) => (
                            <div
                                key={item.id}
                                className="accounting-dashboard-sales-category-table-row px-2 py-3"
                            >
                                <span className="text-truncate">{item.name}</span>
                                <span className="text-center">
                                    ${item?.total_sales?.toLocaleString()}
                                </span>
                            </div>
                        ))
                    ) : (
                        <div className="accounting-dashboard-sales-category-table-row px-2 py-3">

                            <span className="text-truncate">
                                No hay datos disponibles.
                            </span>
                            <span className="text-center">
                                ...
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SalesCategoryPanel;
